import { TranslateFunction } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.types.ts';
import { I18Namespaces } from '@dealstack/shared/lib/common/i18n/i18n.ts';
import { convertCurrencyToSymbol } from '@dealstack/shared/lib/format/currency/currency';
import {
	formatNumber,
	extractDecimalPrecisionFromUnitDenominator,
} from '@dealstack/shared/lib/format/number';
import { GetInvestorTransactionDetailsRes } from '@dealstack/shared/lib/generated';
import type { TransactionTotals } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetails/components/TransactionTable/transactionTable.types.ts';
import { InvestorHoldingRow } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/HoldingsCard/investorHoldings.types.ts';

/** The holding's own units and cost: splits aren't rows, and a sale row carries proceeds, not basis. */
export const getHoldingTransactionTotals = (
	holding: InvestorHoldingRow,
	transactions: GetInvestorTransactionDetailsRes[]
): TransactionTotals => ({
	volume: holding.isIssuedInCurrency ? null : holding.units,
	volumeDecimalScale: Math.max(
		0,
		...transactions.map((transaction) =>
			extractDecimalPrecisionFromUnitDenominator(transaction.securityUnitDenominator)
		)
	),
	cost: holding.totalCostActual,
});

export const getHoldingTransactionsSubtitle = ({
	holding,
	tMipManage,
	securityTypeLabel,
}: {
	holding: InvestorHoldingRow;
	tMipManage: TranslateFunction<I18Namespaces.MIP_MANAGE>;
	securityTypeLabel: string;
}): string =>
	holding.isIssuedInCurrency
		? tMipManage('investors.details.holding_transactions.subtitle_amount', {
				securityType: securityTypeLabel,
				securityName: holding.securityName,
				amount: `${convertCurrencyToSymbol(holding.currency)} ${formatNumber({
					value: holding.units,
					lockPrecision: true,
				})}`,
			})
		: tMipManage('investors.details.holding_transactions.subtitle', {
				securityType: securityTypeLabel,
				securityName: holding.securityName,
				units: formatNumber({ value: holding.units }),
			});
